// Deprecated. Import from 'metadata.js' directly instead.
export { getCountryCallingCode as default } from './metadata';
//# sourceMappingURL=getCountryCallingCode.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/es6/getCountryCallingCode.js
// module id = 184
// module chunks = 0